// extracted by mini-css-extract-plugin
export default {"SessionList":"SessionList_SessionList__FaKDu"};